import React from "react"

function AlignLeft({ size }) {
    return <svg viewBox="0 0 24 24" height={size}><path d="M4 22H2V2h2v20zM22 7H6v3h16V7zm-6 7H6v3h10v-3z"></path></svg>
}

export default AlignLeft